import { Navigate } from '@sorare/routing';

import { FOOTBALL_LALIGA } from '@sorare/core/src/constants/__generated__/routes';

const LaLigaSantanderPage = () => {
  return <Navigate to={FOOTBALL_LALIGA} />;
};
export default LaLigaSantanderPage;
